export default __webpack_public_path__ + "static/media/inactive.900a873f.svg";